import type { AudioMode } from 'expo-av';
import { InterruptionModeIOS, InterruptionModeAndroid } from 'expo-av';

const audioMode: AudioMode = {
  allowsRecordingIOS: false,
  interruptionModeIOS: InterruptionModeIOS.DoNotMix,
  playsInSilentModeIOS: true,
  shouldDuckAndroid: true,
  interruptionModeAndroid: InterruptionModeAndroid.DoNotMix,
  playThroughEarpieceAndroid: false,
  staysActiveInBackground: true,
};

export const audioModeWithRecording: AudioMode = {
  ...audioMode,
  allowsRecordingIOS: true,
};

export const audioModeNoRecording: AudioMode = {
  ...audioMode,
  allowsRecordingIOS: false,
};
